import { Component, Inject, DOCUMENT, HostListener, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, RouterState, ActivatedRoute } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { faPowerOff, faUser } from '@fortawesome/free-solid-svg-icons';
import { TokenService } from 'src/app/shared/services/token.service';
import { AppConfigService } from 'src/app/shared/services/app-config.service';

@Component({
    selector: 'app-nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.scss'],
    standalone: false
})
export class NavBarComponent {
  isCollapsed = true;
  allocationMenuActive = false;
  isAllocateDropdownOpen = false;
  isProfileDropdownOpen = false;
  faUser: any = faUser;
  faPowerOff: any = faPowerOff;

  allocationMenuItems = [
    { link: '/allocate/allocation-list', label: 'Allocate Trades' },
    { link: '/allocate/view-today-orders', label: 'View Today\'s Orders' },
    { link: '/allocate/view-allocations', label: 'View Today\'s Allocations' },
    { link: '/allocate/view-log', label: 'View Allocations Log' },
  ];

  constructor(
    public auth: AuthService,
    public title: Title,
    private router: Router,
    private tokenService: TokenService,
    private appConfigService: AppConfigService,
    private elementRef: ElementRef,
    @Inject(DOCUMENT) private doc: Document
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.title.setTitle(this.getTitle(this.router.routerState, this.router.routerState.root).join('-'));
      }
    });
  }

  getTitle(state: RouterState, parent: ActivatedRoute): string[] {
    const data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data['title']) {
      data.push(parent.snapshot.data['title']);
    }
    if (state && parent && parent.firstChild) {
      data.push(...this.getTitle(state, parent.firstChild));
    }
    return data;
  }

  loginWithRedirect(): void {
    this.auth.loginWithRedirect();
  }

  logout(): void {
    const config = this.appConfigService.getConfig();
    const appUri = config?.appUri;

    this.tokenService.clearToken();
    this.auth.logout({
      logoutParams: {
        returnTo: appUri
      }
    });
  }

  onRouterLinkActive(element) {
    this.allocationMenuActive = element.doc.location.pathname.includes('/allocate/');
  }

  toggleAllocateDropdown(event: Event): void {
    event.stopPropagation();
    this.isAllocateDropdownOpen = !this.isAllocateDropdownOpen;
    this.isProfileDropdownOpen = false;
  }

  toggleProfileDropdown(event: Event): void {
    event.stopPropagation();
    this.isProfileDropdownOpen = !this.isProfileDropdownOpen;
    this.isAllocateDropdownOpen = false;
  }

  closeDropdowns(): void {
    this.isAllocateDropdownOpen = false;
    this.isProfileDropdownOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.closeDropdowns();
    }
  }
}
